import ReactPDF from '@react-pdf/renderer';

export const styles = ReactPDF.StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica',
    fontSize: '9px',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingBottom: 10,
  },
  logoContainer: {
    width: 100,
    height: 100,
  },
  logo: {
    width: '90px',
    borderRadius: '8px',
  },
  companyInfo: {
    marginLeft: 10,
    flex: 1,
  },
  companyName: {
    fontFamily: 'Helvetica-Bold',
  },
  companyAddress: {
    marginTop: 3,
  },
  receiptTitle: {
    fontFamily: 'Helvetica-Bold',
    textAlign: 'right',
    fontSize: 12,
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    marginVertical: 10,
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingVertical: 10,
  },
  label: {
    width: 100,
    fontFamily: 'Helvetica-Bold',
  },
  value: {
    flex: 1,
  },
  flex1: {
    flex: 1,
  },
  font10: {
    fontSize: '10px',
  },
  amountRow: {
    flexDirection: 'row',
    marginTop: 30,
    marginBottom: 30,
    fontSize: 14,
    alignItems: 'center',
    width: '50%',
  },
  contentCenter: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
  },
  marginBottom: {
    marginBottom: 4,
  },
  rowFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  amountLabel: {
    width: 100,
    fontFamily: 'Helvetica-Bold',
  },
  textBold: {
    fontFamily: 'Helvetica-Bold',
  },
  amountValue: {
    width: 200,
    fontFamily: 'Helvetica-Bold',
    backgroundColor: '#f0f0f0',
    padding: 5,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginRight: 40,
  },
  footerText: {
    textAlign: 'center',
  },
  footerLogo: {
    width: 100,
    height: 100,
    marginTop: 10,
  },
  invoiceNumContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    flexDirection: 'row',
    gap: 4,
  },
  invoiceNum: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },
  horizontalContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    justifyContent: 'space-between',
  },
  verticalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
});
